export default "__VITE_ASSET__26YB8Z7z__"